module.exports = __webpack_public_path__ + "static/img/home_zjgx_pic4.213b0a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_zjgx_pic4.png
// module id = 27dw
// module chunks = 0